import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Aboutus/Aboutus.css";
import { AboutData } from "../../Data/Data";

const Aboutus = () => {

  const {
    bannerImage,
    headtitle,
    headdetails,
    principles,
    managements,
    aboutus
  } = AboutData;

  /* Convert AIMS / OBJECTIVES / VISION */
  const headTitles = ["AIMS", "OBJECTIVES", "VISION"];

  return (
    <div className="about-wrapper">

      {/* HERO BANNER */}

      <section
        className="about-banner"
        style={{ backgroundImage: `url(${bannerImage})` }}
      >
        <div className="banner-overlay text-center">
          <div className="container">

            <h1 className="banner-title">
              Know About Northanian
            </h1>

            <p className="banner-subtitle">
              {headtitle}
            </p>

          </div>
        </div>
      </section>



      {/* AIMS OBJECTIVES VISION CARDS */}

      <section className="headdetails-section">

        <div className="content-container">

          <div className="row g-4">

            {headdetails.map((text, index) => {

              const cleanText = text.replace(/^(AIMS|OBJECTIVES|VISION)\s*-\s*/i, "");

              return (
                <div
                  key={index}
                  className="col-lg-4 col-md-6 col-12"
                >

                  <div className="head-card">

                    <h5 className="head-card-title">
                      {headTitles[index]}
                    </h5>

                    <p className="head-card-text">
                      {cleanText}
                    </p>

                  </div>

                </div>
              );
            })}

          </div>

        </div>

      </section>



      {/* OPERATING PRINCIPLES */}

      <section className="principles-section">

        <div className="container">

          <h4 className="text-center mb-4">
            Foundational Standards
          </h4>

          <div className="row g-3">

            {principles.map((item) => (

              <div
                key={item.id}
                className="col-lg-4 col-md-6 col-sm-12"
              >

                <div className="principle-card">

                  <img
                    src={item.image}
                    alt={item.title}
                    className="principle-img"
                  />

                  <div className="principle-overlay">
                    <h6>{item.details}</h6>
                  </div>

                  <div className="principle-caption">
                    {item.title}
                  </div>

                </div>

              </div>

            ))}

          </div>

        </div>

      </section>



      {/* LEADERSHIP */}

      <section className="leadership-section">

        <div className="leadership-container">

          {managements.map((person, index) => (

            <div
              className={`leadership-card shadow ${
                index % 2 !== 0 ? "reverse-card" : ""
              }`}
              key={person.id}
            >

              <img
                src={person.image}
                alt={person.name}
                className="leader-photo"
              />

              <div className="leadership-content">

                <h6 className="leadership-name">
                  {person.name}
                </h6>

                <h5 className="leadership-title">
                  {person.title}
                </h5>

                <div className="leadership-text">
                  {person.description}
                </div>

              </div>

            </div>

          ))}

        </div>

      </section>



      {/* ABOUT SCHOOL */}

      <section className="about-school-section">

        <div className="content-container">

          <h3 className="about-title">
            About The Institution
          </h3>

          {aboutus.map((item, index) => (

            <p key={index} className="about-text">
              {item}
            </p>

          ))}

        </div>

      </section>

    </div>
  );
};

export default Aboutus;